import React from 'react';

interface ToggleButtonProps {
  checked: boolean;
  onChange: (state: boolean) => void;
  /** Names the switch for screen readers. The button has no text of its own. */
  ariaLabel?: string;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({ onChange, checked, ariaLabel }) => {
  const toggle = () => {
    onChange(!checked);
  };

  return (
    <button
      className={`pdq-react-toggle  + ${checked ? 'pdq-react-toggle-on' : 'pdq-react-toggle-off'}`}
      aria-label={ariaLabel}
      onClick={toggle}>
      <div
        className={`icon-${checked ? 'check' : 'cross'} pdq-react-toggle-icon + ${checked ? 'pdq-react-toggle-icon-checked' : ''}`}></div>
      <span className="pdq-react-toggle-pin" />
    </button>
  );
};
